// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Js_exn = require("rescript/lib/js/js_exn.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var IsNewQueryParam = require("./IsNewQueryParam.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MarketingProfileSubpages_marketingProfile_graphql = require("../../__generated__/MarketingProfileSubpages_marketingProfile_graphql.bs.js");

function path(page) {
  switch (page) {
    case "BasicInfo" :
        return "/account/marketing_profile/basic_info";
    case "Photos" :
        return "/account/marketing_profile/photos";
    case "Bio" :
        return "/account/marketing_profile/about";
    case "SocialMedia" :
        return "/account/marketing_profile/social_media";
    case "Url" :
        return "/account/marketing_profile/url";
    
  }
}

function displayName(hasFullProfile, page) {
  switch (page) {
    case "BasicInfo" :
        return "Basic Info";
    case "Photos" :
        if (hasFullProfile) {
          return "Profile Picture & Featured Portrait";
        } else {
          return "Profile Picture";
        }
    case "Bio" :
        return "About You";
    case "SocialMedia" :
        return "Social Media";
    case "Url" :
        return "Custom profile URL";
    
  }
}

function useDisplayName() {
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return React.useCallback((function (page) {
                return displayName(hasFullProfile, page);
              }), [hasFullProfile]);
}

var Agent = {
  path: path,
  displayName: displayName,
  useDisplayName: useDisplayName
};

function path$1(page) {
  switch (page) {
    case "BasicInfo" :
        return "/account/team_marketing_profile/basic_info";
    case "Photos" :
        return "/account/team_marketing_profile/photos";
    case "About" :
        return "/account/team_marketing_profile/about";
    case "SocialMedia" :
        return "/account/team_marketing_profile/social_media";
    case "Members" :
        return "/account/team_marketing_profile/members";
    case "Url" :
        return "/account/team_marketing_profile/url";
    
  }
}

function displayName$1(hasFullProfile, page) {
  switch (page) {
    case "BasicInfo" :
        return "Basic Info";
    case "Photos" :
        if (hasFullProfile) {
          return "Logo and team photo";
        } else {
          return "Logo";
        }
    case "About" :
        return "About";
    case "SocialMedia" :
        return "Social Media";
    case "Members" :
        return "Members";
    case "Url" :
        return "Custom profile URL";
    
  }
}

function useDisplayName$1() {
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  return React.useCallback((function (page) {
                return displayName$1(hasFullProfile, page);
              }), [hasFullProfile]);
}

var Team = {
  path: path$1,
  displayName: displayName$1,
  useDisplayName: useDisplayName$1
};

var Page = {
  Agent: Agent,
  Team: Team
};

function teamPageToPageData(hasFullProfile, page) {
  var displayName$2 = displayName$1(hasFullProfile, page);
  var path$2 = path$1(page);
  return {
          page: page,
          displayName: displayName$2,
          path: path$2
        };
}

function useTeamProfilePages(isNewOpt, param) {
  var isNew = isNewOpt !== undefined ? isNewOpt : false;
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var match = IsNewQueryParam.use();
  var isNew$p = match[0] || isNew;
  var pages = hasFullProfile ? (
      isNew$p ? [
          "BasicInfo",
          "Url",
          "Photos",
          "About",
          "SocialMedia",
          "Members"
        ] : [
          "BasicInfo",
          "Photos",
          "About",
          "SocialMedia",
          "Members",
          "Url"
        ]
    ) : [
      "BasicInfo",
      "Photos",
      "Members"
    ];
  return pages.map(function (page) {
              return teamPageToPageData(hasFullProfile, page);
            });
}

function agentPageToPageData(hasFullProfile, page) {
  var displayName$2 = displayName(hasFullProfile, page);
  var path$2 = path(page);
  return {
          page: page,
          displayName: displayName$2,
          path: path$2
        };
}

function useAgentProfilePages() {
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var pages = hasFullProfile ? [
      "BasicInfo",
      "Photos",
      "Bio",
      "SocialMedia",
      "Url"
    ] : [
      "BasicInfo",
      "Photos"
    ];
  return pages.map(function (page) {
              return agentPageToPageData(hasFullProfile, page);
            });
}

var convertFragment = MarketingProfileSubpages_marketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MarketingProfileSubpages_marketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function useSubpagesForCurrentAccount(marketingProfile) {
  var marketingProfile$1 = useOpt(marketingProfile);
  if (marketingProfile$1 === undefined) {
    return ;
  }
  var match = marketingProfile$1.__typename;
  var marketingProfileType;
  switch (match) {
    case "AgentMarketingProfile" :
        marketingProfileType = "AgentProfile";
        break;
    case "TeamMarketingProfile" :
        marketingProfileType = "TeamProfile";
        break;
    default:
      marketingProfileType = Js_exn.raiseError("Invalid marketing profile type");
  }
  var agentPages = useAgentProfilePages();
  var teamPages = useTeamProfilePages(undefined, undefined);
  if (marketingProfileType === "AgentProfile") {
    return {
            TAG: "AgentPages",
            _0: agentPages
          };
  } else {
    return {
            TAG: "TeamPages",
            _0: teamPages
          };
  }
}

exports.Page = Page;
exports.teamPageToPageData = teamPageToPageData;
exports.useTeamProfilePages = useTeamProfilePages;
exports.agentPageToPageData = agentPageToPageData;
exports.useAgentProfilePages = useAgentProfilePages;
exports.Fragment = Fragment;
exports.useSubpagesForCurrentAccount = useSubpagesForCurrentAccount;
/* react Not a pure module */
